module.exports = __webpack_public_path__ + "static/media/Palazzo Reale - DK Chocolate - LT Grey_White.0235099b.jpg";